<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Company Tax Registration: {{ locationName }}</h3>
        </template>

        <slot>
            <p class="text-right mt-1">
                <button class="btn btn-link" @click.prevent="setToEIN()">Use Company EIN</button>
            </p>

            <div class="card mb-2" v-for="taxRegistration in sortedCompanyTaxRegistrations">
                <div class="card-header pr-1 d-flex justify-content-between">
                    <h4 class="pt-1">{{ taxRegistration.sym_tax.description }}</h4>
                    <more-info class="my-0">
                        <slot name="popover-helper">
                            Symmetry Tax ID: {{ taxRegistration.sym_tax.unique_tax_id }}
                        </slot>
                    </more-info>
                </div>

                <div class="card-body">
                    <tax-registration-form
                        ref="companyTaxRegistrationForms"
                        :unique-tax-id="taxRegistration.sym_tax.unique_tax_id"
                        :has-rate="taxRegistration.sym_tax.needs_rate"
                        :usesEIN="stateCode == 'FED'"
                        :value="taxRegistration"
                    />
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import TaxRegistrationForm from './TaxRegistrationForm'

export default {
    props: ['companyTaxRegistrations', 'client', 'company', 'locationName', 'stateCode'],
    mixins: [FormMixin, ModalMixin],
    components: {TaxRegistrationForm, },
    computed: {
        sortedCompanyTaxRegistrations() {
            const result = Array.from(this.companyTaxRegistrations)
            result.sort((a, b) => a.sym_tax.sort_priority > b.sym_tax.sort_priority ? 1 : -1)
            return result
        },
    },
    methods: {
        getFormData() {
            const result = {}
            this.$refs.companyTaxRegistrationForms.forEach(f => {
                const ctr =
                result[f.uniqueTaxId] = f.getFormData()

            })

            return {taxes: result}
        },
        onSubmit() {
            let isValid = true
            this.$refs.companyTaxRegistrationForms.forEach(f => {
                isValid = f.validate() && isValid
            })
            if (!isValid) {
                return
            }

            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/companies/${this.company.id}/tax-registrations`

            this.$api.put(url, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
        setToEIN() {
            this.$refs.companyTaxRegistrationForms.forEach(f => {
                f.setFilingID(this.company.EIN)
            })
        },
    }
}
</script>
